import { CloseIcon, Dialog, IconButton, Image, useTheme } from '@shared/components';
import { useMediaQuery } from '@shared/hooks';

export interface PreviewImageModalProps {
  open: boolean;
  image?: string;
  onClose?: () => void;
}

export default function PreviewImageModal(props: Readonly<PreviewImageModalProps>) {
  const { open: isOpen, image, onClose } = props;

  const theme = useTheme();
  const isTabletOrDesktop = useMediaQuery(theme.breakpoints.up('tablet'));

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      sx={{
        mx: 'auto',
        my: 'auto',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
        maxHeight: '80vh',
      }}
      fullScreen={!isTabletOrDesktop}
    >
      <Image
        src={image ?? ''}
        alt='Captured frame'
        sx={{
          width: `100%`,
          height: `100%`,
          display: 'block',
          objectFit: 'cover',
          borderRadius: theme.shape.rounded(2),
          [theme.breakpoints.down('tablet')]: {
            borderRadius: 0,
          },
        }}
      />
      <IconButton
        onClick={(e) => {
          e.stopPropagation();
          onClose?.();
        }}
        sx={(theme) => ({
          p: theme.spacing(2),
          backgroundColor: theme.palette.grey[100],
          position: 'absolute',
          right: '16px',
          top: '16px',
          '.MuiSvgIcon-root': {
            fontSize: '24px',
          },
        })}
      >
        <CloseIcon />
      </IconButton>
    </Dialog>
  );
}
